import apiClient from "services/apiClient";

async function updateUniversalImages(page: any, appName: string, fileId: any) {
  const params = new URLSearchParams({
    setting: page,
    app_name: appName,
  });

  if (fileId) {
    params.append("file_id", fileId);
  }

  const url = `/admin/universal-settings-images?${params.toString()}`;
  const res = await apiClient.put(url);
  return res.data;
}

export default updateUniversalImages;
